import { event } from 'vue-gtag'

export const gaTrackByEvent = (eventName, eventCategory, eventLabel) => {
  event(eventName, {
    event_category: eventCategory,
    event_label: eventLabel
  })
}
